var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmailLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.453 10.7837H24.4358V10.7313H13.07V15.7828H20.2071C19.1659 18.7234 16.368 20.8342 13.07 20.8342C8.88554 20.8342 5.49286 17.4415 5.49286 13.257C5.49286 9.07255 8.88554 5.67987 13.07 5.67987C15.0016 5.67987 16.7589 6.40854 18.0969 7.59879L21.6689 4.02678C19.4134 1.92475 16.3964 0.628418 13.07 0.628418C6.09588 0.628418 0.441406 6.28289 0.441406 13.257C0.441406 20.2312 6.09588 25.8857 13.07 25.8857C20.0442 25.8857 25.6987 20.2312 25.6987 13.257C25.6987 12.4103 25.6115 11.5838 25.453 10.7837Z",
    fill: "#FBC02D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89844 7.37905L6.04757 10.4219C7.17026 7.64236 9.88921 5.67987 13.071 5.67987C15.0025 5.67987 16.7598 6.40854 18.0978 7.59879L21.6698 4.02678C19.4144 1.92475 16.3974 0.628418 13.071 0.628418C8.22033 0.628418 4.01373 3.36694 1.89844 7.37905Z",
    fill: "#E53935"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0708 25.8857C16.3327 25.8857 19.2967 24.6374 21.5376 22.6073L17.6291 19.2999C16.3612 20.2603 14.7851 20.8342 13.0708 20.8342C9.78606 20.8342 6.99702 18.7398 5.94632 15.8169L1.82812 18.9898C3.91816 23.0796 8.16265 25.8857 13.0708 25.8857Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4533 10.7839L25.4432 10.7314H24.4361H13.0703V15.7829H20.2074C19.7073 17.1954 18.7987 18.4134 17.6267 19.3006C17.6274 19.3 17.628 19.3 17.6286 19.2993L21.5372 22.6068C21.2606 22.8581 25.6989 19.5715 25.6989 13.2572C25.6989 12.4104 25.6118 11.5839 25.4533 10.7839Z",
    fill: "#1565C0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailLogo);
export default __webpack_public_path__ + "static/media/gmail_logo.0af98728ae2517d3fd40557fe9aaac14.svg";
export { ForwardRef as ReactComponent };